<h1 mat-dialog-title>Additional Information</h1>

<mat-dialog-content class="dialog-content">
  <div *ngIf="!isLoading">
    <mat-card style="margin: 1rem 0;">
      <mat-card-content>
        <div class="info-grid">
          <p *ngIf="headerInfoData.articleName != null">
            <strong>{{ 'component.fields.articleName' | transloco }}:</strong> {{ headerInfoData.articleName }}
          </p>
          <p *ngIf="headerInfoData.articleNumber != null">
            <strong>{{ 'component.fields.articleNumber' | transloco }}:</strong> {{ headerInfoData.articleNumber }}
          </p>
          <p *ngIf="headerInfoData.comment != null">
            <strong>{{ 'packagingUnit.fields.comment' | transloco }}:</strong> {{ headerInfoData.comment }}
          </p>
          <p *ngIf="headerInfoData.manufacturer != null">
            <strong>{{ 'component.fields.manufacturer' | transloco }}:</strong> {{ headerInfoData.manufacturer }}
          </p>
          <p *ngIf="headerInfoData.gtin != null">
            <strong>{{ 'component.fields.gtin' | transloco }}:</strong> {{ headerInfoData.gtin }}
          </p>
          <p *ngIf="totalGrammage != null">
            <strong>{{ 'component.fields.totalGrammage' | transloco }}:</strong> {{ totalGrammage }} {{ 'component.fields.totalGrammageUnit' | transloco }}
          </p>
          <p *ngIf="manufacturingCountry != null">
            <strong>{{ 'component.fields.manufacturingCountry' | transloco }}:</strong> {{ manufacturingCountry }}
          </p>
          <p *ngIf="distributionCountries != null && distributionCountries.length > 0">
            <strong>{{ 'component.fields.countriesOfDistribution' | transloco }}:</strong>
            {{ distributionCountries }}
          </p>

          <p *ngIf="associatedTagIdentifiers != null && associatedTagIdentifiers.length > 0">
            <strong>{{ 'dataManagement.tags.titleTags' | transloco }}:</strong>
            <app-tag-directive [tags]="getTagsFromIds(associatedTagIdentifiers)" [maxDisplayed]="8">
            </app-tag-directive>
          </p>
        </div>
      </mat-card-content>
    </mat-card>

    <div>
      <app-doc-upload-section [areaDto]="headerInfoData.docArea" [isEditable]="false">
      </app-doc-upload-section>
    </div>

    <div>
      <app-image-upload [canEditForm]="false" [hideEdit]="true" [images]="headerInfoData.images">
      </app-image-upload>
    </div>
    <div>
      <app-certificate-upload [canEditForm]="false" [hideEdit]="true" [certificates]="headerInfoData.certificates" [certificateTypes]="allCertificateTypes">
      </app-certificate-upload>
    </div>
    <div>
      <app-pdf-upload [canEditForm]="false" [hideEdit]="true" [pdfs]="headerInfoData.documents">
      </app-pdf-upload>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button (click)="closeDialog()" mat-raised-button type="button">
    {{ 'common.buttons.close' | transloco }}</button>
</mat-dialog-actions>
